import { connect } from "react-redux";
import { IntlProvider as ReactIntlProvider } from "react-intl";

// Preserve the existing action and state contract without the obsolete peer ceilings.
export const UPDATE = "@@intl/UPDATE";

export const updateIntl = ({ locale, formats, messages }) => ({
	type: UPDATE,
	payload: { locale, formats, messages },
});

export const intlReducer = (state = { locale: "en", messages: {} }, action) =>
	action.type === UPDATE ? { ...state, ...action.payload } : state;

export const IntlProvider = connect(({ intl }) => ({ key: intl.locale, ...intl }))(ReactIntlProvider);
